module.exports = __webpack_public_path__ + "static/media/24.1ce3158f.png";